import { render, staticRenderFns } from "./SkeletonEvent.vue?vue&type=template&id=5216a228&scoped=true&"
import script from "./SkeletonEvent.vue?vue&type=script&lang=js&"
export * from "./SkeletonEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216a228",
  null
  
)

export default component.exports